module.exports = __webpack_public_path__ + "img/6taskStatus.93be20d1.svg";